import { createElementBlock as r, openBlock as n, normalizeClass as o, renderSlot as a, createElementVNode as s } from "vue";
import { _ as c } from "./main-DQQ1cljm.js";
const d = {
  name: "TextNode",
  props: {
    modelValue: {
      type: Object
    }
  },
  computed: {
    node() {
      return this.modelValue;
    },
    customClasses() {
      var e;
      return ((e = this.node.properties) == null ? void 0 : e.customClasses) || [];
    },
    anchorTag() {
      var e;
      return ((e = this.node.properties) == null ? void 0 : e.anchorTag) || "";
    },
    content() {
      return this.node.content.html || this.node.content.caption;
    }
  }
};
function l(e, p, m, u, i, t) {
  return n(), r("div", {
    class: o(["pb-text", t.customClasses]),
    "data-anchor-tag": t.anchorTag
  }, [
    a(e.$slots, "default", {}, () => [
      s("div", {
        class: "html-wrapper",
        innerHTML: t.content
      }, null, 8, ["innerHTML"])
    ], !0)
  ], 10, ["data-anchor-tag"]);
}
const _ = /* @__PURE__ */ c(d, [["render", l], ["__scopeId", "data-v-fd4f3609"]]);
export {
  _ as default
};
